import { Device, DeviceInfo } from '@capacitor/device';

interface ClientInfo {
  app: 'MEM' | 'CUS' | 'TEC';
  screen: {
    viewportWidth: number;
    viewportHeight: number;
    screenWidth: number;
    screenHeight: number;
    pixelRatio: number;
  };
  connection: {
    effectiveType: string;
    downlink: number;
    rtt: number;
  };
  mobile?: Partial<DeviceInfo>;
}

let deviceInfoPromise: Promise<DeviceInfo> | null = null;

export const getDeviceInfo = async () => {
  if (!deviceInfoPromise) {
    deviceInfoPromise = Device.getInfo();
  }
  return deviceInfoPromise;
};

export function getClientInfo(): ClientInfo {
  const navigatorInfo = navigator as any;
  const connection =
    navigatorInfo.connection || navigatorInfo.mozConnection || navigatorInfo.webkitConnection;

  return {
    app: 'TEC',
    screen: {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      pixelRatio: window.devicePixelRatio,
    },
    connection: {
      effectiveType: connection?.effectiveType || 'Unknown',
      downlink: connection?.downlink || 0,
      rtt: connection?.rtt || 0,
    },
  };
}
